export default {
    items: [
        {
            name: 'Dashboard',
            url: '/dashboard',
            icon: 'fa fa-tachometer',
            badge: {
                variant: 'info',
                text: 'NEW',
            },
        },
        {
            name: 'Reports',
            url: '/reports',
            icon: 'fa fa-bar-chart',
            children: [

            ]
        }
    ],
};
